// @flow

import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { assetUrl } from '~/src/config/routes.js';
import SVG from 'react-inlinesvg';
import t from '~/src/services/i18n';
import './EditorHeader.scss';

const EditorHeader = () => (
  <Fragment>
    <h4 className="header-text" >{t('uploadWidgetDemo')}</h4>
    <NavLink exact to="/product-gallery">
      <SVG className="btn-close" src={assetUrl('Icons/close.svg')} />
    </NavLink>
  </Fragment>
);

export default EditorHeader;
